import { IBaseAnalyticsCombined } from "@/store/analyticsDataStore";
import { AgChartOptions } from "ag-charts-community";
import { AgCharts } from "ag-charts-react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-balham.css"; // Optional Theme applied to the grid
import "ag-grid-enterprise";
import { useTheme } from "next-themes";
import { useMemo } from "react";
import { darkAnalyticFills, lightAnalyticFills } from "../AnalyticsStyles";

const CounterpartyDonut = ({
  filteredData,
}: {
  filteredData: IBaseAnalyticsCombined[];
}) => {
  const { theme } = useTheme();

  const options = useMemo<AgChartOptions>(
    () => ({
      theme: theme == "dark" ? "ag-default-dark" : "ag-default",
      background: {
        visible: false,
      },
      data: filteredData,
      series: [
        {
          type: "donut",
          calloutLabelKey: "counterparty",
          angleKey: "tradesWon",
          fills: theme == "dark" ? darkAnalyticFills : lightAnalyticFills,
        },
      ],
      legend: {
        position: "right",
      },
    }),
    [theme, filteredData],
  );

  return (
    <div className="flex h-full w-full overflow-hidden">
      <div className="flex h-full w-full flex-col">
        <div>Trades Won by Counterparty</div>
        <div
          id="NotionalByCounterpartyBar"
          className="flex h-full w-full overflow-hidden"
        >
          <AgCharts className="flex h-full w-full" options={options} />
        </div>
      </div>
    </div>
  );
};

export default CounterpartyDonut;
